import { FunctionComponent } from 'react';

type CollapseIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
};

const CollapseIcon: FunctionComponent<CollapseIconProps> = ({
  width = 34,
  height = 34,
  active = false,
}) => {
  const circleFill = active ? '#561BDC' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : '#3E3B5F';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-916 -962)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(916 962)"
          fill={circleFill}
        />
        <g transform="translate(24.512 64.512)">
          <rect
            width="6.462"
            height="6.462"
            transform="translate(899.488 917.027)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M64,17.693V8H78.77V22.77H69.077"
            transform="translate(838.719 897.488)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <line
            x1="4.731"
            y2="4.731"
            transform="translate(907.939 910.259)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <path
            d="M144,144v3.785h3.785"
            transform="translate(763.536 767.702)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default CollapseIcon;
